import { get } from 'svelte/store';
import { auth_locked_devices, device_auths } from 'src/stores/device-runtime/local-auth';

/**
 * Syncs auth_locked_devices and device_auths based on device auth status.
 * Add to locked when auth enabled and no stored credentials; remove and clear credentials when auth disabled.
 *
 * @param deviceId - Real device id (real_id format).
 * @param authEnabled - Whether device authentication is enabled.
 * @returns True if device was added to locked (caller may need to trigger401 etc.).
 */
export const syncAuthLockedFromAuthEnabled = (deviceId: string, authEnabled: boolean): boolean => {
	const hasCredentials =
		typeof (get(device_auths) as Record<string, unknown>)?.[deviceId] !== 'undefined' &&
		(get(device_auths) as Record<string, unknown>)?.[deviceId] !== null;
	if (authEnabled === true && !hasCredentials) {
		auth_locked_devices.add(deviceId);
		return true;
	}
	if (authEnabled === false) {
		device_auths.remove(deviceId);
		auth_locked_devices.remove(deviceId);
	}
	return false;
};
